module.exports = __webpack_public_path__ + "media/images/landing/second/photo18-7dcf86c3bfe65bc466050d5343557a6a.jpg";